import  { useState, useEffect } from 'react';
// UI
import { useTheme, Typography, useMediaQuery, Button} from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import MexicoRed from '../../assets/mundial/mexico_red.svg';
import MexicoGreen from '../../assets/mundial/mexico_green.svg';
import { menuOptions } from '../../utils/menuOptions';


const WorldCup2026 = ({close, onDateReached}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const colorGreen = '#006847'
  const colorRed = '#CE1126'
  const colorWhite = '#fff'
  const strokeSize = '1px'

  const cssTextGreenStrokeWhite = {
    color:colorGreen,
    WebkitTextStroke: `${strokeSize} ${colorWhite}`
  }

  // 11 de Junio de 2026, 12:00 PM CST
  const worldCupStartDate = new Date('2026-06-11T12:00:00-06:00'); 

  const calculateTimeLeft = () => {
    const difference = +Number(worldCupStartDate) - +Number(Date.now());
    let timeLeft = {};
    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }

    return {timeLeft, difference};
  };

  const [timeLeft, setTimeLeft] = useState({
    timeLeft:{
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
    },
    difference: 0
  });

  useEffect(() => {
    const timer = setInterval(() => {
      const newTimeLeft = calculateTimeLeft();

      setTimeLeft(newTimeLeft);

      if (newTimeLeft.difference <=0) {
        onDateReached();
        return clearInterval(timer);
      }
      
      // Detener el contador si la fecha límite ha sido alcanzada
      if (Object.keys(newTimeLeft.timeLeft).length === 0) {
        clearInterval(timer);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (time) => {
    return time < 10 ? `0${time}` : time;
  };

  return(
    <>
      <div style={{
        backgroundColor: '#FFFFFFAB', 
        fontWeight: '600',
        borderRadius:'10px', 
        width: isMobile ? 'calc(100% - 40px)' : '300px',
        marginTop: '20px',
        padding:'35px 0px',
        display: timeLeft.difference<=0?'none':'block',
        position:'fixed',
        top:'100px',
        left:'20px',
        zIndex:'2',
        height:'200px',
      }}>
        <CancelOutlinedIcon
          style={{
            position:'absolute',
            right:'10px',
            top:'10px',
            cursor:'pointer',
            zIndex:'2',
            color:colorGreen,
          }}
          onClick={close}
        />
        <img src={MexicoRed} alt='Oasis' 
          style={{
            position:'absolute',
            left:'65%',
            top:'10px',
          }}
        />
        <img src={MexicoGreen} alt='Oasis' 
          style={{
            position:'absolute',
            left:'15%',
            bottom:'10px',
          }}
        />
        <Typography
          variant='h1'
          sx={{
            fontSize:{xs: '1.5rem', sm: '1.5rem', md: '1.5rem', lg: '1.5rem', textAlign: 'center'}
          }}
          textAlign='center'
        >
          <span style={{
            ...cssTextGreenStrokeWhite,

          }}>
            Mundial México
          </span>
        </Typography>
        <Typography
          variant='h1'
          sx={{
            fontSize:{xs: '1.5rem', sm: '1.5rem', md: '1.5rem', lg: '1.5rem', textAlign: 'center'}
          }}
          textAlign='center'
        >
          <span style={cssTextGreenStrokeWhite}>
            2026
          </span>
        </Typography>
        <p style={{
          fontSize:'0.8rem',
          color: colorRed,
          textAlign:'center',
          margin:'0px'
        }}>
        Solo faltan:
        </p>
        <div style={{
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'space-evenly',
          color: colorRed,
          fontSize:'0.9rem',
        }}>
          <div>
            <div style={{
              position: 'relative', 
              display: 'flex',
              flexDirection: 'column',
              textAlign: 'center'
            }}>
              <span>
                {formatTime(timeLeft.timeLeft.days)}
              </span>
              <span style={{
                color: colorGreen,
              }}>
                Días
              </span>
            </div>
          </div>
          <span>
            :
          </span>
          <div>
            <div style={{
              position: 'relative', 
              display: 'flex',
              flexDirection: 'column',
              textAlign: 'center'
            }}>
              <span>
                {formatTime(timeLeft.timeLeft.hours)}
              </span>
              <span style={{
                color: colorGreen,
              }}>
                Horas
              </span>
            </div>
          </div>
          <span>
            :
          </span>
          <div>
            <div style={{
              position: 'relative', 
              display: 'flex',
              flexDirection: 'column',
              textAlign: 'center'
            }}>
              <span>
                {formatTime(timeLeft.timeLeft.minutes)}
              </span>
              <span style={{
                color: colorGreen,
              }}>
                Minutos
              </span>
            </div>
          </div>
          <span>
            :
          </span>
          <div>
            <div style={{
              position: 'relative', 
              display: 'flex',
              flexDirection: 'column',
              textAlign: 'center'
            }}>
              <span>
                {formatTime(timeLeft.timeLeft.seconds)}
              </span>
              <span style={{
                color: colorGreen,
              }}>
                Segundos
              </span>
            </div>
          </div>
        </div>
        {/* <div style={{
          display: 'flex',
          justifyContent: 'center',
          marginTop: '10px',
        }}>
          <Button
            href={`${menuOptions.EVENTS.path}?category=17&name=Mundial+de+Fútbol+2026`}
            variant='contained'
            color='secondary'
            aria-label='Text CTA'
            fullWidth={false}
            size='small'
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              textAlign: 'center',
              textDecoration: 'none',
              textTransform: 'none',
              borderRadius: '50px',
              backgroundColor:colorGreen,
              color:colorWhite,
              fontSize:'0.8rem',
            }}>
            Ver partídos <ArrowForwardIcon/>
          </Button>
        </div> */}
      </div>
    </>
  );
}


export default WorldCup2026;